import React from "react";
import Footer from "../components/footer";
import Menu from "../components/menu";
import Page from "../components/page";
import Presentation from "../components/presentation";

class Home extends React.Component {
    state = {
        view: <Presentation />,
    }

    handleUpdateView(view: object) {
        this.setState({
            view
        });
    }

    render() {
        return (
            <Page>
                <div className="container-home">
                    <div className="container-menu">
                        <Menu onView={(view) => this.handleUpdateView(view)} />
                    </div>
                    <div className="container-content">
                        <div className="container-general">
                            {this.state.view}
                        </div>
                        <Footer />
                    </div>
                </div>
            </Page>
        );
    }
}

export default Home;